var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1024 1023.998",
    height: "1023.998px",
    id: "Facebook_3_",
    viewBox: "0 0 1024 1023.998",
    width: "1024px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.9397 0.3421 -0.3421 0.9397 840.8065 -105.4355)",
    gradientUnits: "userSpaceOnUse",
    id: "bg_2_",
    x1: 231.4619,
    x2: -426.9561,
    y1: 1084.9287,
    y2: 300.3513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1921,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    style: {
      stopColor: "#212121"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#494948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545453"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512.001,
    cy: 511.999,
    fill: "url(#bg_2_)",
    id: "bg_1_",
    r: 512
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 1 428.6797 183.0771)",
    gradientUnits: "userSpaceOnUse",
    id: "Shadow_1_",
    x1: -20.1997,
    x2: 470.0476,
    y1: 177.4419,
    y2: 667.6893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#090909",
      stopOpacity: 0.5167
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181818",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M635.896,1008.824L447.25,820.18l0.688-2.069l-0.375-182.859l-96.313-96.07l0.396-1.848  L467,433.999l32-126l13-51l49-23l101.333-23.167l9.917-6.583l0.5-0.319l349.684,349.652  C1022.434,553.582,1008.795,906.649,635.896,1008.824z",
    fill: "url(#Shadow_1_)",
    id: "Shadow"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M672.75,305.64V203.89c-3.736,0-7.473-0.007-11.209,0.001  c-8.996,0.02-17.993-0.022-26.99,0.001c-10.972,0.028-21.941-0.046-32.915,0.001c-9.667,0.042-19.337-0.097-29.003,0.003  c-14.592,0.151-28.442,0.868-42.438,5.375c-13.493,4.346-26.158,11.955-36.948,21.081c-6.248,5.284-12.031,10.943-17.269,17.234  c-2.121,2.613-4.098,5.33-5.942,8.14c-5.538,8.431-9.913,17.704-13.567,27.535c-0.82,2.213-1.628,4.432-2.396,6.662  c-5.634,16.324-5.82,34.143-5.82,51.297c0,2.148,0,4.363,0,6.629c0,33.984,0,79.291,0,79.291h-97v112h93.5h2.5v281h111v-283.5  L659,537.999l13.583-110.125L558.75,427.64v-85c0,0-0.25-36.25,30.5-36.75L672.75,305.64z",
    fill: "#FFFFFF",
    id: "Facebook"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.085422129ca7619806e642fccb4e49d2.svg";
export { ForwardRef as ReactComponent };